import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {validateField} from '../../../actions/helpers/validation'
import {
  fetchProductionActivateDataSuccess,
  validateProductionActivateField,
  submitProductionActivateFields,
  clearProductionActivateFields,
  clearProduction} from '../../../actions/pages/production-page'
import EditForm from '../../../pages/EditForm'
import InputField from '../../common/form/InputField'
import CheckboxField from '../../common/form/CheckboxField'
import UploadFileField from '../../../pages/UploadFileField'
import Textarea from '../../../pages/Textarea'
import Alert from '../../../ui-elements/alerts/Alert'
import ImageInCoverStyle from '../../common/helpers/ImageInCoverStyle'
import ImageQualityProgressBar from '../../common/helpers/ImageQualityProgressBar'
import '../../../css/ui-elements/modals.css'

class ActivateOrEditProductionPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      className: 'modal-primary',
      size: 'lg',
      errorMsg: null,
      posterUrl: null,
      HasUserSelectedImage: false
    }

    this.toggle = this.toggle.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.openPopup = this.openPopup.bind(this)
  }

  openPopup() {
    let id = parseInt(this.props.productionId, 10);

    if (!Number.isInteger(id)){
      return;
    }

    this.toggle();

    let url = 'productions/' + id;

    this.props.clearProductionActivateFields();
    this.setState({
      errorMsg: null,
      posterUrl: null
    })

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchProductionActivateDataSuccess(data);

      this.setState({
        posterUrl: data.PosterUrl
      })
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    })
  }

  submitForm(event) {
    event.preventDefault();

    let validatedFields = this.props.fields.map(field => validateField(field))

    let isValid =
        validatedFields.filter(field => field.errors.length > 0).length > 0
          ? false
          : true

    this.props.submitProductionActivateFields(validatedFields);

    if (!isValid){
      return;
    }

    let dataToSend = {}
    this.props.fields.forEach((field) => {
      dataToSend[field.name] = field.value;
    })

    this.props.ajax.getImageAsBlob(this.state.posterUrl, (responseAsBlob) => {
      dataToSend['PosterFile'] = responseAsBlob;
      dataToSend['HasUserSelectedImage'] = this.state.HasUserSelectedImage;

      let formData = this.convertToFormData(dataToSend);
      this.putData(formData);
    });
  }

  convertToFormData(data) {
    var formData = new FormData();
    formData.append("BodyJson", JSON.stringify(data));
    formData.append("PosterFile", data['PosterFile']);
    return formData;
  }

  putData(formData) {
    let productionStatus = this.props.productionOverview.Status;
    let url = 'productions/' + this.props.productionId ;

    if (productionStatus === 'Draft') {
      url = url + '/activate';
    }

    this.props.ajax.put(
      url,
      formData,
      null,
      (response) => {
        if (response.Status === 'OK') {
          this.toggle();
          this.props.clearProduction();
          this.props.notify(`The production was ${productionStatus === 'Draft' ? 'activated' : 'updated'}.`);
        }
        else{
          this.setState({
            errorMsg: `Can not ${productionStatus === 'Draft' ? 'activate' : 'update'} production (id: ${this.props.productionId})`
          })
        }
      })
  }

  handleSelectedImage = (selectedImageValue) => {
        this.setState({HasUserSelectedImage: selectedImageValue});
  }

  render() {
    let productionStatus = this.props.productionOverview.Status;

    if (productionStatus !== 'Draft' && productionStatus !== 'Active') {
      return (null)
    }

    let fields = this.props.fields;
    let posterField = fields[3];

    // prepare view for loaded image
    var that = this;
    if (posterField && posterField.value) {
      var reader = new FileReader();

      reader.onload = function(ev) {
        if (that.state.posterUrl !== ev.target.result){
          that.setState({
            posterUrl: ev.target.result
          })
        }
      }
      reader.readAsDataURL(posterField.value);
    }


    return (
      <div style={{display: 'inline-block'}}>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          wrapClassName={this.state.className}
          size={this.state.size}>
          <ModalHeader toggle={this.toggle}>{productionStatus === 'Draft' ? 'Activate production': 'Edit production'}</ModalHeader>
          <ModalBody>
            {this.state.errorMsg &&
              <Alert className="alert alert-danger alert-outline">
                {this.state.errorMsg}
              </Alert>
            }
            <EditForm
              title=""
              description="">

              {fields[0] && <InputField field={fields[0]} validate={this.props.validateProductionActivateField} />}
              {fields[1] && <Textarea field={fields[1]} validate={this.props.validateProductionActivateField} rows="5" />}
              {fields[2] && <CheckboxField field={fields[2]} validate={this.props.validateProductionActivateField} />}

              {this.state.posterUrl && <ImageInCoverStyle imageUrl={this.state.posterUrl} width="150px" height="200px" />}
              {posterField && <UploadFileField onSelectedImage={this.handleSelectedImage.bind(this)} field={posterField} validate={this.props.validateProductionActivateField} />}

              {this.state.posterUrl && !this.state.posterUrl.includes("produb.app") && <ImageQualityProgressBar imageUrl={this.state.posterUrl} refWidth={1200} refHeight={1800}/>}

            </EditForm>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary btn-rounded" type="submit" onClick={this.submitForm}>
            {productionStatus === 'Draft' ? 'Activate': 'Save'}
            </button>
            <button className="btn btn-default btn-rounded" onClick={this.toggle}>
              Close
            </button>
          </ModalFooter>
        </Modal>

        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={this.openPopup}>
          {productionStatus === 'Draft' ? 'Activate': 'Edit'}
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  productionOverview: state.productionPage.overview,
  fields: state.productionActivate.fields
})
const mapDispatchToProps = dispatch => ({
  fetchProductionActivateDataSuccess: (activateData) => dispatch(fetchProductionActivateDataSuccess(activateData)),
  submitProductionActivateFields: fields => dispatch(submitProductionActivateFields(fields)),
  validateProductionActivateField: (value, field) => dispatch(validateProductionActivateField(value, field)),
  clearProductionActivateFields: () => dispatch(clearProductionActivateFields()),
  clearProduction: () => dispatch(clearProduction())
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(ActivateOrEditProductionPopup)
